import { useContext } from "react";
import { BreadcrumbsContext } from "@/components/Breadcrumbs";
export function useBreadcrumbs() {
  return useContext(BreadcrumbsContext);
}